import type { GexLevels } from '../services/gexCalculator';
import type { GexStrikeBandPoint } from '../types/marketAnalytics';

/** Near-spot GEX band for wall-proximity heatmap (module 1). */
export function buildGexStrikeBand(
  levels: GexLevels | null,
  nearSpotPct = 0.08,
  maxPoints = 28,
): GexStrikeBandPoint[] {
  if (!levels?.strikes?.length || levels.spot <= 0) return [];

  const spot = levels.spot;
  const lo = spot * (1 - nearSpotPct);
  const hi = spot * (1 + nearSpotPct);
  const callWall = levels.callWall;
  const putWall = levels.putWall;

  const filtered = levels.strikes
    .filter((s) => s.strike >= lo && s.strike <= hi)
    .sort((a, b) => a.strike - b.strike);

  const slice = filtered.length > maxPoints
    ? filtered.slice(Math.max(0, Math.floor(filtered.length / 2) - maxPoints / 2), Math.ceil(filtered.length / 2) + maxPoints / 2)
    : filtered;

  const maxAbs = Math.max(...slice.map((s) => Math.abs(s.netGex)), 1);

  return slice.map((s) => {
    const dCall = Math.abs(s.strike - callWall) / spot;
    const dPut = Math.abs(s.strike - putWall) / spot;
    const wall_proximity = Math.max(0, Math.min(1, 1 - Math.min(dCall, dPut) * 25));
    return {
      strike: s.strike,
      net_gex: s.netGex,
      abs_gex: Math.abs(s.netGex),
      wall_proximity,
      is_call_wall: s.strike === callWall,
      is_put_wall: s.strike === putWall,
    };
  });
}
